import { DenyCircle } from '@squareup/dex-icons/market/alert';
import { ApiExplorerInputType } from '@squareup/dex-types-shared-api-explorer';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import { isNull } from '@squareup/dex-utils-shared-json';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

const strings = {
  nullPlaceholder: 'Filled as null',
  emptyStringPlaceholder: 'Filled as empty string',
};

interface UsePrimitivePropsResult {
  placeholder: string;
  icon?: ReactNode;
}

interface UseSchemaPropsResult extends UsePrimitivePropsResult {
  comboboxValue: string | undefined;
}

const usePrimitiveProps = (
  placeholder: string,
  currentValue: ApiExplorerInputType | undefined,
  isEmptyStringAllowed = true
): UsePrimitivePropsResult => {
  const icon = (
    <DenyCircle
      slot="leading-accessory"
      className={clsx(
        commonIconStyles['icon-fill-current-color'],
        commonIconStyles['icon-current-color-20']
      )}
      width={16}
      height={16}
      viewBox="0 0 24 24"
    />
  );

  if (isNull(currentValue)) {
    return {
      placeholder: strings.nullPlaceholder,
      icon,
    };
  } else if (currentValue === '' && isEmptyStringAllowed) {
    return {
      placeholder: strings.emptyStringPlaceholder,
      icon,
    };
  }

  return {
    placeholder,
  };
};

const useSchemaProps = (
  placeholder: string,
  currentValue: ApiExplorerInputType | undefined,
  comboboxValue: string | undefined
): UseSchemaPropsResult => {
  const icon = (
    <DenyCircle
      slot="leading-accessory"
      className={clsx(
        commonIconStyles['icon-fill-current-color'],
        commonIconStyles['icon-current-color-20']
      )}
      width={16}
      height={16}
      viewBox="0 0 24 24"
    />
  );

  if (isNull(currentValue)) {
    return {
      placeholder: strings.nullPlaceholder,
      icon,
      comboboxValue: strings.nullPlaceholder,
    };
  } else if (currentValue === '') {
    return {
      placeholder: strings.emptyStringPlaceholder,
      icon,
      comboboxValue: strings.emptyStringPlaceholder,
    };
  }

  return {
    placeholder,
    comboboxValue,
  };
};

export { usePrimitiveProps, useSchemaProps };
